// src/pages/ExtrasPage.jsx
import VendorExtrasForm from "../components/vendorForm";

const ExtrasPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10">
      <VendorExtrasForm />
    </div>
  );
};

export default ExtrasPage;
